import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api-client';
import type { InvoiceDirection } from './use-applied-provisional';

export interface PricingReadiness {
  has_required_pricing_inputs: boolean;
  missing_fields: string[];
  ticket_id: string | null;
  // Sell-side Provisional gate signals: the deal needs a hedge before pricing
  // is known, and whether the side's price is already fixed.
  needs_hedge: boolean;
  price_fixed: boolean;
  // Whether the side's final weight is recorded. Final = price_fixed &&
  // weight_fixed; anything less renders as provisional.
  weight_fixed: boolean;
}

export function pricingReadinessKey(blOrderId: string | undefined, direction: InvoiceDirection) {
  return ['bl-order-pricing-readiness', blOrderId, direction] as const;
}

export function usePricingReadiness(blOrderId: string | undefined, direction: InvoiceDirection) {
  return useQuery<PricingReadiness>({
    queryKey: pricingReadinessKey(blOrderId, direction),
    enabled: blOrderId !== undefined && blOrderId.length > 0,
    queryFn: () =>
      apiRequest<PricingReadiness>(
        `/bl-orders/${encodeURIComponent(blOrderId ?? '')}/pricing-readiness?direction=${direction}`,
      ),
  });
}
